import type { MarkTutorialSeenRequest, UserTutorialResponse, UserType } from '~/composables/onboarding/types';

export async function fetchDoneGuides(userType: UserType, userName: string) {
  try {
    return await useCustomFetch<UserTutorialResponse>(
      `${useMsUrls().orderWrapperBaseUrl}/User/${userType}/${userName}`
    );
  } catch {
    return {
      id: '',
      createdAt: '',
      userId: userName,
      userType: userType,
      seenTutorialsList: [],
    } satisfies UserTutorialResponse;
  }
}

export async function updateDoneGuide(request: MarkTutorialSeenRequest) {
  try {
    await useCustomFetch<string[]>(`${useMsUrls().orderWrapperBaseUrl}/User/MarkTutorialSeen`, {
      method: 'POST',
      body: request,
    });
  } catch {
    // ignore
  }
}
